import React from 'react';
import styled from 'styled-components';

import vw from 'src/styles/utils';
import media from 'src/styles/media';

const FormHeader = (props) => {
  return (
    <Root>
      <Left
        src={require('src/assets/images/sales-tools/logo_tab.svg')}
        alt="logo"
      />
      {/* <Right
        src={require('src/assets/images/sales-tools/logo_towersix_primary.svg')}
        alt="logo"
      /> */}
    </Root>
  );
};

FormHeader.propTypes = {};

export default FormHeader;

const Root = styled.section`
  width: 100%;
  ${vw('padding-left', 25, 60, 60)}
  ${vw('padding-right', 25, 60, 174)}
  /* ${vw('margin-bottom', 120)} */
  display: flex;
  flex-direction: column;
  @media ${media.tablet} {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
  }
`;

const Left = styled.img`
  ${vw('width', 114)}
  ${vw('height', 200)}
  ${vw('margin-bottom', 20, 0, 0)}
`;

const Right = styled.img`
  ${vw('width', 247)}
  ${vw('height', 80)}
  ${vw('margin-bottom', 15)}
`;
